import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { useState, useContext } from 'react'
import PaperDraggable from '../../../../../../components/PaperDraggable'
import SelectQuery from '../../../../../../components/SelectQuery'
import SelectFormaRecebimentoMultiple from '../../../../../../components/SelectsSimpleApiQuery/SelectFormaRecebimento/Multiple'
import DateComIntervalo from '../../../../../../components/DateComIntervalo'
import { TFiltrosResumoState } from '..'
import { AuthContext } from '../../../../../../contexts/AuthContext'
import moment from 'moment'

export default function FiltroModal({
    open,
    onClose,
    onFilterSubmit,
    onClearFilters,
    filters
}: FiltroModalProps) {

    const { userPerfilComLoja } = useContext(AuthContext);
    const [internFilters, setInternFilters] = useState<TFiltrosResumoState>(filters);

    return (
        <>
            <Dialog
                id="draggable-dialog-title"
                open={open}
                onClose={onClose}
                maxWidth="sm"
                fullWidth
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle sx={{ cursor: "move" }}>Filtros</DialogTitle>

                <DialogContent>
                    <Grid container spacing={2} sx={{ py: 2 }}>
                        <Grid size={{xs: 12, md: 6}}>
                            <SelectQuery
                                defaultValue={internFilters.loja ? [internFilters.loja] : []}
                                query="pesquisar-lojas"
                                type="field"
                                label="Loja"
                                titleModal="Selecionar Loja"
                                emptyLabel="-"
                                multiple={false}
                                permitirLimpar={false}
                                returnOnlyId={false}
                                autoSelectFirst={userPerfilComLoja?.loja ? false : true}
                                onChange={(values) => {
                                    setInternFilters((prevState) => ({ ...prevState, loja: values[0] }));
                                }}
                                extraParams={{ somente_vinculadas: Boolean(userPerfilComLoja?.loja) }}
                            />
                        </Grid>

                        <Grid size={{xs: 12, md: 6}}>
                            <DateComIntervalo
                                icon={false}
                                data={{
                                    inicial: filters.data_inicio,
                                    final: filters.data_fim
                                }}
                                onChangeData={(data) => {
                                    setInternFilters(prevState => ({ ...prevState, data_inicio: data.inicial ?? moment() }))
                                    setInternFilters(prevState => ({ ...prevState, data_fim: data.final ?? moment() }))
                                }}
                                datePickerView={['year', 'month', 'day']}
                                formatString="DD/MM/YYYY"
                                labelInput="Periodo"
                            />
                        </Grid>

                        <Grid size={{xs: 12}}>
                            <SelectFormaRecebimentoMultiple
                                isDisabled={!internFilters.loja}
                                loja_id={internFilters.loja?.id ?? 1}
                                value={internFilters.forma_recebimento}
                                onChange={(newValue) => setInternFilters((prevState) => ({ ...prevState, forma_recebimento: newValue }))}
                            />
                        </Grid>


                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => {
                            onClearFilters();
                            onClose();
                        }}
                    >
                        Limpar
                    </Button>

                    <Button
                        autoFocus
                        variant="contained"
                        onClick={() => {
                            onFilterSubmit({...internFilters, pagina: 0});
                            onClose();
                        }}
                    >
                        Filtrar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

interface FiltroModalProps {
    open: boolean;
    onClose: () => void;
    onFilterSubmit: (filters: TFiltrosResumoState) => void;
    onClearFilters: () => void;
    filters: TFiltrosResumoState;
}
